import { IGlobalState } from '../../../Root/store/appReducer'
import { CustomType, GoalId } from '../../../services/api.types'
import { ProgressPeriod } from '../../../components/YumProgressPeriod/YumProgressPeriod'
import { PointsLogicId } from '../../ChallengeAdmin/components/ChallengePoints/ChallengePoints'

// TODO: Store and get per goalId ???
export const getManualEntryProgressTypeSelector = (state: IGlobalState) => state.progress.manualEntryProgressType
export const getManualEntryPointsLogicIdSelector = (state: IGlobalState) => state.progress.manualEntryPointsLogicId

export const getProgressResultsSelector = (state: IGlobalState) => state.progress.progressResults

export const getCustomProgressRawSelector = (state: IGlobalState, goalId: GoalId) =>
  state.progress.customProgress && state.progress.customProgress[goalId] ? state.progress.customProgress[goalId] : []

export const getCustomProgressSelector = (state: IGlobalState, goalId: GoalId, pointsLogicId?: PointsLogicId | null) =>
  state.progress.customProgress ? state.progress.customProgress[goalId]?.[pointsLogicId || 'default'] : []

export const getDailyProgressSelector = (state: IGlobalState, customType: CustomType | null) =>
  state.progress.dailyProgress && customType ? state.progress.dailyProgress[customType] : []

/*export const getDailyProgressWithPeriodSelector = (
  state: IGlobalState,
  customType: CustomType | null,
  progressPeriod: ProgressPeriod,
) => {
  if (!state.progress.dailyProgress || !customType) return []
  const diary = state.progress.dailyProgress[customType]
  return
}*/

export const getAllDailyProgressSelector = (state: IGlobalState) => state.progress.dailyProgress

export const selectTotalPointsProgress = (state: IGlobalState, goalId: GoalId) =>
  state.progress.pointsProgress && state.progress.pointsProgress[goalId] ? state.progress.pointsProgress[goalId] : []

export const getIsManualEntryInProgress = (state: IGlobalState) => state.progress.manualEntryInProgress

export const getLastBonusPointsAdded = (state: IGlobalState) => state.progress.lastBonusPointsAdded
